import {
    initialLikeInfoPopupState,
    LikeInfoPopupState,
} from 'mk2/apps/blogs/containers/LikeInfoPopup/LikeInfoPopup.reducers';
import { AppState } from 'mk2/reducers';

export const getLikeInfoPopupState = (state: AppState, entityType: string, entityId: number): LikeInfoPopupState =>
    state.containers.blogs.shared.likeInfoPopups[`${entityType}/${entityId}`] || initialLikeInfoPopupState;
